import { CompositeFramePartsType, CompositeFramePartsVariationType } from "constants/dataTypes";
import { stringToSlug } from "./slug";

export const getFrameVariation = (frame_products: CompositeFramePartsType, frame_color: string, frame_size: string) => {
    let frame_variation: CompositeFramePartsVariationType | undefined;
    frame_products?.product?.variations?.map((variation: any) => {
        if (variation.meta.attribute_pa_color === frame_color && variation.meta.attribute_pa_size === frame_size) {
            frame_variation = variation;
        }
    });

    return frame_variation;
}

export const getArmVariation = (arm_products: CompositeFramePartsType, arm_color: string, arm_size: string) => {
    let arm_variation: CompositeFramePartsVariationType | undefined;
    arm_products?.product?.variations?.filter((variation: any) => {
        if (variation.meta.attribute_pa_color === arm_color && variation.meta.attribute_pa_size === arm_size && 'region_product_ids' in variation.meta) {
            arm_variation = variation;
        }
    });

    return arm_variation;
}
export const getArmVariationOldSystem = (arm_products: any, arm_color: string, arm_size: string) => {
    
    let arm_variation: any;
    arm_products?.variations?.nodes.filter((variation: any) => {
        var attrColor = variation.attributes.nodes.filter((attribute: any) => {
            return attribute.name === 'pa_color';
        });

        var attrSize = variation.attributes.nodes.filter((attribute: any) => {
            return attribute.name === 'pa_size';
        });

        if (stringToSlug(attrColor[0].value) === arm_color && attrSize[0].value === arm_size) {
            arm_variation = variation;
        }
    });

    return arm_variation;
}


export const getTreatmentVariation = (treatmentName: string, slug: string) => {
    if ((treatmentName.includes('polarised-grey-mirror') || treatmentName.includes('polarised-brown-mirror')) && slug == 'polarised') {
        return false;
    }

    return treatmentName.includes(slug);
}